import { NgModule } from '@angular/core';
import { CrmInjectionToken } from './providers';
import { CrmCoreModule } from '@galaxy/crm/static';

@NgModule({
  imports: [CrmCoreModule.forRoot(CrmInjectionToken)],
})
export class VendorCrmModule {}
